import React, { useEffect, useState } from 'react';
import {
	getInitatives,
	getWaves,
	getInitativeCreators,
	patchInitative,
} from 'utils/apiRequests';
import NoInitiatives from './EmptyPages/NoInitiatives';
import NoAllocatedInitiative from './EmptyPages/NoAllocatedInitiative';
import Planner from './Planner/Planner';

const WavesContainer = () => {
	const [initiatives, setInitiatives] = useState([]);
	const [waves, setWaves] = useState([]);
	const [creators, setCreators] = useState([]);

	const updateInitiativeDuration = (id, data) => {
		patchInitative(id, data).then(() => {
			getInitatives().then(result => {
				setInitiatives(result);
			});
		});
	};

	useEffect(() => {
		getInitatives().then(result => {
			setInitiatives(result);
		});
		getWaves().then(result => {
			setWaves(result);
		});
		getInitativeCreators().then(creators => {
			setCreators(creators);
		});
	}, []);
	const isNoAllocated = initiatives.every(initiative => !initiative.waveId);
	if (isNoAllocated) {
		return <NoAllocatedInitiative />;
	}
	if (initiatives.length) {
		return (
			<Planner
				waves={waves}
				initiatives={initiatives}
				creators={creators}
				updateInitiativeDuration={updateInitiativeDuration}
			/>
		);
	}
	return <NoInitiatives />;
};

export default WavesContainer;
